/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import SiteReferrerEvent from '../../event/SiteReferrerEvent'
import { SiteReferrerState } from '../state/SiteReferrerState'

class SiteReferrersStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case SiteReferrerEvent.fetchAll:
        const site_referrers = payload.site_referrers.map(site_referrer => {
          return new SiteReferrerState(site_referrer)
        })
        return List(site_referrers)
      default:
        return state
    }
  }
}

export default new SiteReferrersStore()
